import { GetArrayUniformLocation, GetUniformLocation } from './utils/pipeline-utils-gl';
import { fragSamplerColourMatrix } from '../shaders/frag-sampler-colourMatrix.shader';
import { vertSampler } from '../shaders/vert-sampler.shader';

import { RegionMask } from './components/regionMasks/regionMask';
import { ColourMatrixUniformData } from './pipeline-colourMatrix';
import { TexturePipelineBase } from './pipeline-texBase';

export class ColourMatrixTexturePipeline extends TexturePipelineBase {
  public constructor(regionMaskColour = '') {
    super(vertSampler, fragSamplerColourMatrix);

    if (regionMaskColour) {
      this.regionMask = new RegionMask();
      this.fragShader = RegionMask.ModifyFragShaderText(this.fragShader, regionMaskColour);
    }
  }

  protected InitShaderProps(shaderProgram: WebGLProgram) {
    super.InitShaderProps(shaderProgram);

    this.shaderProgramProps.u_colorMatrix = GetArrayUniformLocation(
      this.gl,
      shaderProgram,
      'uColorMatrix[0]',
      this.constructor.name
    );
    this.shaderProgramProps.u_alpha = GetUniformLocation(
      this.gl,
      shaderProgram,
      'uAlpha',
      this.constructor.name
    );
  }

  public Draw(uniformData: ColourMatrixUniformData): void {
    super.Draw(uniformData);
  }

  public DrawOnceForPixelData(uniformData: ColourMatrixUniformData): Uint8Array {
    return super.DrawOnceForPixelData(uniformData);
  }

  protected SetUniforms(data: ColourMatrixUniformData) {
    super.SetUniforms(data);

    this.gl.uniform1fv(this.shaderProgramProps.u_colorMatrix, data.matrix_4x5);
    this.gl.uniform1f(this.shaderProgramProps.u_alpha, data.alpha);
  }
}
